import { render, staticRenderFns } from "./minimumStock.vue?vue&type=template&id=131cdbd0"
import script from "./minimumStock.vue?vue&type=script&lang=js"
export * from "./minimumStock.vue?vue&type=script&lang=js"
import style0 from "./minimumStock.vue?vue&type=style&index=0&id=131cdbd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports